<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="要料信息" name="1">
        <van-field v-model="inputForm.applyCode" label="要料单编号" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.projectName" label="所属项目" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.requireDate" label="要料日期" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.applyModeLabel" label="要料方式" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.operatorName" label="经办人" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.operatorLinkPhone" label="要料人联系方式" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.helpPersonName" label="要料协调人" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.planArrivalDate" label="计划到货日期" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.consignee" label="收货联系人" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.consigneeLinkPhone" label="收货人联系方式" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.consigneeAddress" label="收货详细地址" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="120px"
                   readonly input-align="left" :border="false" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="120px"
                   readonly input-align="left" :border="false" />
      </van-collapse-item>
      <van-collapse-item title="材料信息" name="2">
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.detailList" :fields="fields1" foot-clone>
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(applyNum)="data">
            {{ Number(data.item.applyNum).toFixed(4) }}
          </template>
          <template v-slot:cell(remarks)="data">
            <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
          <template v-slot:foot()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
          </template>
          <template v-slot:foot(index)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
          </template>
          <template v-slot:foot(applyNum)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(inputForm.detailList, 'applyNum') }}</div>
          </template>
        </b-table>
        <van-field v-model="inputForm.remarks" label="备注" label-width="120px"
                   readonly input-align="left" :border="false" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
          <p style="color: #AAA">附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
import {Decimal} from "decimal.js";
export default {
  name: "ItsApplyBill",
  data(){
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_apply_bill',
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'materialTypeLabel', label: '材料类型', width: '120px'},
        {key: 'materialCode', label: '材料编码', width: '120px'},
        {key: 'materialName', label: '材料名称', width: '120px'},
        {key: 'materialModel', label: '规格', width: '120px'},
        {key: 'materialUnit', label: '计量单位', width: '120px'},
        {key: 'applyNum', label: '要料数量', width: '120px'},
        {key: 'remarks', label: '备注', width: '120px'},
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/apply/itsApplyBill/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0,10)
        this.getDict([
          ['its_apply_mode', 'applyMode']
        ]);
        this.updateDictNames(this.inputForm.detailList,{its_material_type:'materialType'})
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    viewDetail(){
      this.$router.push({
        path: '/ItsBaseTeamDetail',
        query: {
          data: JSON.stringify(this.inputForm.memberList)
        }
      })
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(4, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>

</style>